import { useEffect, useRef, useState } from 'react'
import Loader from 'react-loaders'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { ToastContainer } from 'react-toastify'

import AnimatedLetters from '../AnimatedLetters/AnimatedLetters'
import { toastError, toastSuccess } from '../Layout/toast'
import './contact.scss'

const Contact = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const [messageSending, setMessageSending] = useState(false)
    const form = useRef()

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    const sendEmail = async (e) => {
        e.preventDefault()

        setMessageSending(true)

        const formData = new FormData(form.current)
        const formDataObject = {}
        formData.forEach((value, key) => {
            formDataObject[key] = value
        })

        try {
            const apiUrl = `${process.env.BACKEND_URL}/api/v1/contactMe`
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formDataObject)
            })

            if (!response.ok) {
                toastError("Please try again later!", 5000)
            }

            form.current.reset()
            toastSuccess("Message has been sent.", 2000)
        } catch (error) {
            toastError("Please try again later!", 5000)
        }

        setMessageSending(false)
    }

    return (
        <>
            <div className="container contact-page">
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
                            idx={15}
                        />
                    </h1>
                    <p>
                        I am interested in freelance opportunities - especially on ambitious
                        or large projects. However, if you have any other requests or
                        questions, don't hesitate to contact me using below form either.
                    </p>
                    <div className="contact-form">
                        <form ref={form} onSubmit={sendEmail}>
                            <ul>
                                <li className="half">
                                    <input placeholder="Name" type="text" name="name" required />
                                </li>
                                <li className="half">
                                    <input
                                        placeholder="Email"
                                        type="email"
                                        name="email"
                                        required
                                    />
                                </li>
                                <li>
                                    <input
                                        placeholder="Subject"
                                        type="text"
                                        name="subject"
                                        required
                                    />
                                </li>
                                <li>
                                    <textarea
                                        placeholder="Message"
                                        name="message"
                                        required
                                    ></textarea>
                                </li>
                                <li>
                                    <input type="submit" className="flat-button" value="SEND" />
                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
                <div className="info-map">
                    Erdinç Atay,
                    <br />
                    Turkey,
                    <br />
                    İstanbul
                    <br />
                    <span>info@erdincatay.com</span>
                </div>
                <div className="map-wrap">
                    <MapContainer center={[41.067139, 28.995425]} zoom={13}>
                        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
                        <Marker position={[41.067139, 28.995425]}>
                            <Popup>I live around here, please let me know before you came over here :)</Popup>
                        </Marker>
                    </MapContainer>
                </div>
            </div>
            <Loader type="pacman" />
            {messageSending && <Loader type="pacman" />}
        </>
    )
}

export default Contact
